import { render, staticRenderFns } from "./ProviderOrders.vue?vue&type=template&id=1a0ab8fe&scoped=true&"
import script from "./ProviderOrders.vue?vue&type=script&lang=js&"
export * from "./ProviderOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0ab8fe",
  null
  
)

export default component.exports